export default __webpack_public_path__ + "static/datadog-5b4775f2bd995cde408f4a3ad8fca149.svg";